import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithWarningLayout.scss';

export default function DialogWithWarningLayout(props) {
  const { children, onYesClick, selfClose, character, footerClassName, yesLabel = 'OK' } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character || 'i'}
      layoutType="error"
      headerClassName="dialog-with-warning-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-warning-layout-footer-wrapper')}
      footer={
        <ButtonWithIcon
          data-e2e="warning-ok"
          type="primary"
          size="small"
          sprite="ChevronRight"
          iconRight
          onClick={clickHandler}
          className="e2e-warning-ok">
          {yesLabel}
        </ButtonWithIcon>
      }>
      {children}
    </DialogsWithIcon>
  );
}

export const propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  character: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  footerClassName: PropTypes.string,
  children: PropTypes.node,
};

DialogWithWarningLayout.propTypes = propTypes;
